<template>
  <section class="list-wrapper">
    <div
      @scroll="scroll"
      @touchend="end"
      @touchmove="move"
      @touchstart="start"
      class="list"
      ref="list"
    >
      <div class="content" ref="content">
        <slot name="header"/>
        <div class="body-box" ref="body">
          <div :class="zoomIn?'zoom-in':''" class="pull-down" ref="pullDown" v-show="false">
            <div class="spinner">
              <i ref="clipper">
                <em ref="circle"></em>
              </i>
            </div>
          </div>
          <slot/>
        </div>

        <div class="load-more">
          <loading v-show="!isRefresh&&loading"/>
          <div class="load-end" v-show="eof">--END--</div>
          <div :style="'height:'+height_tall+';'" class="height_div_tall" v-if="is_height_tall"></div>
        </div>
      </div>
    </div>
    <transition name="fade-enter">
      <div @click="toTop" class="btn to-top" v-show="toTopFlag"></div>
    </transition>
    <!-- <transition name='fade-enter'>
      <loading class='loading' v-show='loading&&fullLoading'/>
    </transition>-->
  </section>
</template>

<script>
import loading from './loading'
// require('../js/iscroll.js');
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    },
    eof: {
      type: Boolean,
      default: false
    },
    unPullUp: {
      type: Boolean,
      default: false
    },
    is_height_tall: {  //底部行高，如果底部有固定导航栏，不加这个会被挡住
      type: Boolean,
      default: true
    },
    height_tall: {  //底部行高的高度
      type: String,
      default: '2.5em'
    }
  },
  data () {
    return {
      y: 0,
      toTopFlag: false,
      fullLoading: true,
      isRefresh: false,
      zoomIn: false
    }
  },
  components: {
    loading
  },
  methods: {
    start (e) {
      this.y = e.touches[0].pageY;
    },
    move (e) {
      //e.preventDefault();
      if (this.loading || this.eof) {
        return;
      }
      var list = this.$refs.list;
      var ST = list.scrollTop;
      // var OH = list.offsetHeight;
      // var SH = list.scrollHeight;
      //var ST=this.$refs.content.style.transform.split('translateZ')[0].split(',')[1].replace(/[^0-9\.]/ig,'');
      var pd = this.$refs.pullDown;
      var h = e.changedTouches[0].pageY;
      switch (true) {
        case ST > 0 && ST < 100 && h > this.y:
          this.y = e.changedTouches[0].pageY;
          break;
        case ST * 1 == 0 && h > this.y:
          e.preventDefault();
          this.zoomIn = false;
          var h = e.changedTouches[0].pageY;
          var H = h - this.y;
          pd.style.top = H - H / 2 + 'px';
          if (H > 30 && H < 120) {
            this.$refs.circle.style.transform = 'rotateZ(' + (120 + H * 2) + 'deg)';
          } else if (H >= 120) {
            this.$refs.clipper.style.transform = 'rotateZ(' + (H - 120) + 'deg)';
          }
          // this.$refs.spinner.style.opacity=(h-this.y)/150;
          break;
        // case SH == OH+ST&&h<this.y:
        //   e.preventDefault();
        //   break;
      }
    },
    end (e) {
      var pd = this.$refs.pullDown;
      var top = pd.style.top.replace(/[^0-9\-\.]/ig, '') * 1;
      switch (true) {
        case top <= 0:
          return;
        case top >= 60:
          if (this.loading)
            return;
          this.isRefresh = true;
          this.$emit('refresh', true);
          this.moveBack(60)
          break;
        default:
          this.moveBack();
          break;
      }
    },
    throttle (callback) {
      clearTimeout(callback.id);
      callback.id = setTimeout(() => {
        callback();
      }, 50)
    },
    scrollHandle () {
      var list = this.$refs.list;
      var ST = list.scrollTop;
      if (ST > 300) {
        this.toTopFlag = true;
      } else {
        this.toTopFlag = false;
      }
      if (this.eof || this.loading) {
        return;
      }
      var OH = list.offsetHeight;
      var SH = list.scrollHeight;
      if (SH - ST < OH + 20) {
        this.isRefresh = false;
        this.$emit('loadMore', true);
      }
    },
    circle () {
      var clipper = this.$refs.clipper;
      // var circle=this.$refs.circle;
      var rotate = clipper.style.transform.replace(/[^0-9\-\.]/ig, '');
      clipper.style.transform = 'rotateZ(' + (rotate - 5) + 'deg)';
      // circle.style.transform='rotateZ('+ (rotate - 10) + 'deg)';
      if (!this.loading) {
        this.zoomIn = true;
        return;
      }
      requestAnimationFrame(() => this.circle());
    },
    moveBack (h) {
      var pd = this.$refs.pullDown;
      var clipper = this.$refs.clipper;
      var circle = this.$refs.circle;
      var top = pd.style.top.replace(/[^0-9\-\.]/ig, '');
      if (top - 10 <= (h || 0)) {
        pd.style.top = (h || 0) + 'px';
        if (h) {
          return this.circle();
        } else {
          clipper.style.transform = 'rotateZ(0deg)';
          circle.style.transform = 'rotateZ(180deg)';
          return;
        }
      }
      pd.style.top = top - 10 + 'px';
      var rotate = clipper.style.transform.replace(/[^0-9\-\.]/ig, '');
      clipper.style.transform = 'rotateZ(' + (rotate - 20) + 'deg)';
      requestAnimationFrame(() => this.moveBack(h));
    },
    scroll (e) {
      if (this.unPullUp) {
        return;
      }
      this.throttle(this.scrollHandle);
    },
    toTop () {
      this.$refs.list.scrollTop = 0;
    },
  },
  computed: {

  },
  watch: {
    loading (val) {
      // this.$nextTick(()=>{
      //   this.myScroll.refresh();
      // })
      if (!val) {
        this.fullLoading = false;
        var pd = this.$refs.pullDown;
        var top = pd.style.top.replace(/[^0-9\-\.]/ig, '');
        if (+top > 0) {
          setTimeout(() => {
            this.moveBack();
          }, 400)
        }
      }
    }
  },
  mounted () {
    // this.myScroll = new IScroll(this.$refs.list ,{
    //   bounce: false,
    //   click:true,
    //   //mouseWheel: true,
    // });
  },
  beforeDestroy () {
    //this.myScroll.destroy();
  }
}
</script>

<style scoped>
.list-wrapper {
  height: 100%;
}
.list {
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  position: relative;
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
}
.content {
  min-height: calc(100% + 1px);
  margin-top: 0;
}
.body-box {
  position: relative;
  /* height: 100%; */
}
.pull-down {
  width: 40px;
  height: 40px;
  box-shadow: 0 0 5px #aaa;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -20px;
  margin-top: -45px;
  border-radius: 50%;
  background: #fff;
  font-size: 30px;
  z-index: 2;
}
.spinner {
  width: 1em;
  height: 1em;
  border-radius: 50%;
  /* box-shadow: inset 0 0 0 .1em rgba(58, 168, 237, .2); */
  position: relative;
  margin: 5px;
  /* opacity: 0; */
}

.spinner i {
  position: absolute;
  clip: rect(0.5em, 1em, 1em, 0);
  width: 1em;
  height: 1em;
  top: 0;
  left: 0;
}
.spinner em {
  position: absolute;
  clip: rect(0.5em, 1em, 1em, 0);
  width: 1em;
  height: 1em;
  content: '';
  border-radius: 50%;
  box-shadow: inset 0 0 0 0.1em #3aa8ed;
  top: 0;
  left: 0;
  transform: rotateZ(180deg);
}
.zoom-in {
  opacity: 0;
  transform: scale3d(0, 0, 0) rotateZ(-360deg);
  transition: all 0.4s;
}
.load-more {
  text-align: center;
}
.load-more div {
  padding: 15px;
}
.load-end {
  color: #999;
}
.to-top {
  position: fixed;
  color: white;
  font-size: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  line-height: 40px;
  background: #fff;
  text-align: center;
  bottom: 90px;
  right: 5px;
  cursor: pointer;
  opacity: 0.8;
  box-shadow: 0 0 4px #999;
}

.to-top::before {
  content: '';
  width: 0;
  height: 0;
  border-bottom: 10px solid #999;
  border-left: 8px solid rgba(0, 0, 0, 0);
  border-right: 8px solid rgba(0, 0, 0, 0);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.to-top:active {
  background: #eee;
}
.loading {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  /* font-size: 25px !important; */
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/scroll_load/scrollerLoad.vue